import React, { useContext } from 'react'
import ShareFlowContext from './ShareFlowContext'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const withShareFlow = (WrappedComponent) => {
  const WithShareFlow = (props) => {
    const {
      init,
      closeConnection,
      standByUntilUserReturn,
      openAppLink,
      initialising,
      resuming,
      active,
      error,
      sharingStatus,
      qrCodeUrl,
      qrCodeAppLinkUrl,
      details,
      displayAsQrCode
    } = useContext(ShareFlowContext)

    const shareFlowProps = {
      shareError: error,
      shareInitialising: initialising,
      shareResuming: resuming,
      shareActive: active,
      shareStatus: sharingStatus,
      shareQrCodeUrl: qrCodeUrl,
      shareQrCodeAppLinkUrl: qrCodeAppLinkUrl,
      shareDetails: details,
      shareDisplayAsQrCode: displayAsQrCode,
      shareActions: {
        initialise: init,
        closeConnection,
        standByUntilUserReturn,
        openAppLink
      },
    }
    return (
      <WrappedComponent {...props} {...shareFlowProps} />
    )
  }
  WithShareFlow.displayName = `WithShareFlow(${getDisplayName(WrappedComponent)})`;
  return WithShareFlow
}

export default withShareFlow
